import minLength from '../../../form/field-validation/minLength';

export const lengthAddressee = length => minLength(length, 'name');
export const lengthAddress = length => minLength(length, 'address');
export const lengthCompany = length => minLength(length, 'company');
export const lengthHouseNumber = length => minLength(length, 'houseNumber');
export const lengthPostCode = length => minLength(length, 'postcode');

export const lengthField = length => minLength(length);
